<template>
  <v-expansion-panel
    bg-color="background"
    @click="loadPlayersScore()"
  >
    <v-expansion-panel-title
      collapse-icon="chevron-up"
      expand-icon="chevron-down"
    >
      <div class="game">
        <div class="game__left">
          <div class="game__date-status">
            <div>{{ game.date.toLocaleString() }}</div>
            <div>{{ game.status }} </div>
          </div>
          <div class="teams">
            <team-picture :team="game.homeTeam" small />
            <team-picture :team="game.awayTeam" small />
          </div>
        </div>
        <div class="game__right">
          <v-btn
            icon
            @click="updateGame()"
          >
            <font-awesome-icon
              :icon="['fas', 'arrows-rotate']"
              size="sm"

            />
          </v-btn>
          <div>Coverage: {{ game.coverage }} </div>
          <div>
            Dernière MAJ des scores:
            {{ game.playersScoreUpdatedAt ? game.playersScoreUpdatedAt.toLocaleString() : 'N/A' }}
          </div>
        </div>
      </div>
    </v-expansion-panel-title>
    <v-expansion-panel-text>
      <div class="score-lists">
        <div class="score-list">
          <team-picture
            :team="game.homeTeam"
            picture-right
          />
          <v-list>
            <player-score
              v-for="(playerScore, index) in homeTeamPlayersScore"
              :key="index"
              :player-score="playerScore"
            />
          </v-list>
        </div>
        <div class="score-list">
          <team-picture :team="game.awayTeam" />
          <v-list>
            <player-score
              v-for="(playerScore, index) in awayTeamPlayersScore"
              :key="index"
              :player-score="playerScore"
            />
          </v-list>
        </div>
      </div>
    </v-expansion-panel-text>
  </v-expansion-panel>
</template>

<script>
import TeamPicture from '@/components/Team/TeamPicture.vue'
import PlayerScore from '@/components/Admin/PlayerScore.vue'
import Game from '@/models/Game/game'
import PlayerScoreService from '@/services/playerScore.service'
import PlayerScoreModel from '@/models/PlayerScore/playerScore'

export default {
  name: 'GamePanel',
  components: {
    TeamPicture,
    PlayerScore,
  },
  props: {
    game: {
      type: Game,
      required: true,
    },
  },
  data() {
    return {
      homeTeamPlayersScore: [],
      awayTeamPlayersScore: [],
    };
  },
  methods: {
    loadPlayersScore() {
      const service = this.game.isNationalTeamGame
        ? PlayerScoreService.getNationalTeamGamePlayersScore
        : PlayerScoreService.getClubGamePlayersScore

      service(this.game.id).then((playersScore) => {
        this.assignPlayersScore(playersScore)
      })
    },
    assignPlayersScore(playersScore) {
      const homeName = this.game.homeTeam.name
      const awayName = this.game.awayTeam.name

        if (this.game.isNationalTeamGame) {
        this.homeTeamPlayersScore = playersScore.filter((playerScore) => playerScore.player.nationalTeam?.name === homeName)
        this.awayTeamPlayersScore = playersScore.filter((playerScore) => playerScore.player.nationalTeam?.name === awayName)
        return
      }

      this.homeTeamPlayersScore = playersScore.filter((playerScore) => playerScore.player.club?.name === homeName)
      this.awayTeamPlayersScore = playersScore.filter((playerScore) => playerScore.player.club?.name === awayName)
    },
    updateGame() {
      const service = this.game.isNationalTeamGame
        ? PlayerScoreService.updatePlayerScoreByNationalTeamGame
        : PlayerScoreService.updatePlayerScoreByClubGame

      service(this.game.id).then((game) => {


        this.$emit('game-update', game)
        this.loadPlayersScore()
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .game {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    &__left {
      display: flex;
      align-items: center;
      gap: 10px;

      .teams {
        display: flex;
        flex-direction: column;
        gap: 8px;
      }
    }
  }

  .score-lists {
    display: flex;
    justify-content: space-between;

    .score-list {
      display: flex;
      flex-direction: column;
    }
  }
</style>
